import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Icon,
  Spacer,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { RiErrorWarningLine } from 'react-icons/ri';
import { NavigationDrawer } from './navigation-drawer';
import { AppBar } from './app-bar';
import { Footer } from './footer';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/auth-provider/context';
import moment from 'moment';
import SubcriptionExpire from './subcription-expire';
const appShell = {
  appBarPosition: 'fixed',
  appBarHeight: '64px',
  navigationDrawerWidth: '256px',
};

function App({ children, ...props }) {
  const [isNavigationDrawerOpen, setIsNavigationDrawerOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { user } = useAuth();
  const cancelRef = React.useRef();
  const location = useLocation();
  const onToggleNavigationDrawer = () => {
    setIsNavigationDrawerOpen(!isNavigationDrawerOpen);
  };
  const today = moment().startOf('day');

  const startDate = moment(user?.idSchool?.subscription?.startDate);
  const endDate = moment(user?.idSchool?.subscription?.endDate);
  const expireDate = moment().diff(endDate, 'days');

  useEffect(() => {
    // console.log({ user });

    // console.log({ sedangBerjalan: today.isBetween(startDate, endDate) });
    if (expireDate > 1) {
      onOpen();
    }
  }, []);

  return !expireDate > 14 ? (
    <SubcriptionExpire />
  ) : (
    <Box id="app" {...props} hidden={location.pathname == '/login'}>
      <NavigationDrawer
        isOpen={isNavigationDrawerOpen}
        onToggleNavigationDrawer={onToggleNavigationDrawer}
      />
      <Box pl={{ base: 0, md: appShell.navigationDrawerWidth }}>
        <AppBar
          navigationDrawerWidth={appShell.navigationDrawerWidth}
          onToggleNavigationDrawer={onToggleNavigationDrawer}
        />
        <Box
          bgColor="gray.100"
          minHeight="100vh"
          display="flex"
          flexDirection="column"
          pt={appShell.appBarHeight}
        >
          <Box>{children}</Box>
          <Spacer />
          <Footer />
        </Box>
      </Box>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              <Text color={'red'} fontSize={'2xl'} textAlign={'center'}>
                <Icon as={RiErrorWarningLine} mt={'2px'} mr={'5px'} />
                Alert Message
              </Text>
            </AlertDialogHeader>

            <AlertDialogBody mb={4} textAlign={'center'}>
              Mohon segera melakukan pembayaran sebelum tanggal{' '}
              <Text fontWeight={'bold'} as={'span'} mr={1}>
                {' '}
                {moment(user?.idSchool?.subscription?.endDate)
                  .add(2, 'weeks')
                  .format('D MMMM YYYY')}
              </Text>
              , masa tenggang selama dua minggu sebelum tanggal jatuh tempo.
            </AlertDialogBody>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}

export { App };
